import React from "react";
import "./NavLinkWithIcon.scss";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
type NavLinkWithIconProps = {
  Icon: any;
  label: string;
  href: string;
  iconClasses?: string;
  handleClick:() => void;
};
const NavLinkWithIcon = ({
  Icon,
  label,
  href,
  iconClasses,
  handleClick
}: NavLinkWithIconProps) => {
  const location = useLocation();
  const { pathname } = location;

  const isActive = pathname === href;
  return (
    <Link
      onClick={()=>handleClick()}
      to={href}
      className={`roting__button ${
        isActive ? "active" : ""
      } rounded-lg flex gap-2`}
    >
      <Icon className={`button-icon ${iconClasses}`} />
      <span className="button-label">{label}</span>
    </Link>
  );
};

export default NavLinkWithIcon;
